import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const sponsorColumn = [
  {
    key: "sponsorname",
    label: "Sponsor Name",
    tooltip: true,
    maxLength: 30,
  },
  {
    key: "sponsoraddress",
    label: "Sponsor Address",
    tooltip: true,
    maxLength: 50,
  },
  {
    key: "sponsorcontact",
    label: "Sponsor Contact",
    tooltip: true,
    maxLength: 10,
  },
  {
    key: "sponsoremail",
    label: "Contact Email",
    tooltip: true,
    maxLength: 30,
  },
  {
    key: "croname",
    label: "CRO Name",
    tooltip: true,
    maxLength: 30,
  },
  {
    key: "crocontact",
    label: "CRO Contact",
    tooltip: true,
    maxLength: 10,
  },
  {
    key: "croemail",
    label: "CRO Email",
    tooltip: true,
    maxLength: 30,
  },
];

export const sponsorFields:FormFieldConfig[] = [
    {
      name: "sponsorname",
      label: "Sponsor Name",
      placeholder: "Enter Sponsor Name",
      required: true,
      rules: validations.sponsor.sponsorName,
    },
    {
      name: "sponsoraddress",
      label: "Sponsor Address",
      placeholder: "Enter Sponsor Address",
      required: false,
      rules: validations.sponsor.sponsorAddress,
    },
    {
      name: "sponsorcontact",
      label: "Sponsor Contact",
      type:"number",
      placeholder: "Enter Sponsor Contact",
      required: false,
      rules: validations.sponsor.sponsorContactPerson,
    },
    {
      name: "sponsoremail",
      label: "Sponsor Email",
      placeholder: "Enter Sponsor Email",
      required: true,
      type: "email" as const,
      rules: validations.sponsor.contactEmail,
    },
    {
      name: "croname",
      label: "CRO Name",
      placeholder: "Enter CRO Name",
      required: true,
      rules: validations.sponsor.croName,
    },
    {
      name: "crocontact",
      label: "CRO Contact",
      placeholder: "Enter CRO Contact",
      type:"number",
      required: false,
      rules: validations.sponsor.croContactPerson,
    },
    {
      name: "croemail",
      label: "CRO Email",
      placeholder: "Enter CRO Email",
      required: false,
      type: "email" as const,
      rules: validations.sponsor.croEmail,
    },
  ];